import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { Layout } from './components/layout/Layout';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { AdminRoute } from './components/admin/AdminRoute';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminManagementPage from './pages/admin/AdminManagementPage';
import HomePage from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { SolutionsPage } from './pages/SolutionsPage';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
import TechnoflexWebModernizationPage from './pages/case-studies/TechnoflexWebModernizationPage';
import OSOPCodingPlatformPage from './pages/case-studies/OSOPCodingPlatformPage';
import OSOPCodingDataEngineeringPage from './pages/case-studies/OSOPCodingDataEngineeringPage';
import ArchitekSolutionsUSAPage from './pages/case-studies/ArchitekSolutionsUSAPage';
import { ContactPage } from './pages/ContactPage';
import { CareersPage } from './pages/CareersPage';
import JobDetailPage from './pages/JobDetailPage';
import RetailEcommercePage from './pages/solutions/RetailEcommercePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import ManufacturingSolutionPage from './pages/solutions/ManufacturingSolutionPage';
import EducationSolutionPage from './pages/solutions/EducationSolutionPage';
import DevOpsPage from './pages/services/DevOpsPage';
import AzureFoundryPage from './pages/services/AzureFoundryPage';
import AzureOpenAIPage from './pages/services/AzureOpenAIPage';
import DataWarehousePage from './pages/services/DataWarehousePage';
import ETLPage from './pages/services/ETLPage';
import BIReportingPage from './pages/services/BIReportingPage';
import ApplicationDevelopmentPage from './pages/services/ApplicationDevelopmentPage';
import ApplicationModernizationPage from './pages/services/ApplicationModernizationPage';
import CloudAzurePage from './pages/services/CloudAzurePage';
import CloudGCPPage from './pages/services/CloudGCPPage';
import CloudAWSPage from './pages/services/CloudAWSPage';

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <ThemeProvider>
          <ToastProvider>
            <AdminAuthProvider>
              <Router>
                <Layout>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/services/azure-foundry" element={<AzureFoundryPage />} />
                    <Route path="/services/azure-open-ai" element={<AzureOpenAIPage />} />
                    <Route path="/services/data-warehouse" element={<DataWarehousePage />} />
                    <Route path="/services/etl" element={<ETLPage />} />
                    <Route path="/services/bi-reporting" element={<BIReportingPage />} />
                    <Route path="/services/application-development" element={<ApplicationDevelopmentPage />} />
                    <Route path="/services/application-modernization" element={<ApplicationModernizationPage />} />
                    <Route path="/services/cloud-azure" element={<CloudAzurePage />} />
                    <Route path="/services/cloud-gcp" element={<CloudGCPPage />} />
                    <Route path="/services/cloud-aws" element={<CloudAWSPage />} />
                    <Route path="/services/cicd-pipelines" element={<DevOpsPage />} />
                    <Route path="/solutions" element={<SolutionsPage />} />
                    <Route path="/solutions/manufacturing" element={<ManufacturingSolutionPage />} />
                    <Route path="/solutions/retail-ecommerce" element={<RetailEcommercePage />} />
                    <Route path="/solutions/education" element={<EducationSolutionPage />} />
                    <Route path="/case-studies" element={<CaseStudiesPage />} />
                    <Route path="/case-studies/technoflex-web-modernization" element={<TechnoflexWebModernizationPage />} />
                    <Route path="/case-studies/osop-coding-platform" element={<OSOPCodingPlatformPage />} />
                    <Route path="/case-studies/osop-coding-data-engineering" element={<OSOPCodingDataEngineeringPage />} />
                    <Route path="/case-studies/architek-solutions-usa" element={<ArchitekSolutionsUSAPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/careers" element={<CareersPage />} />
                    <Route path="/careers/:jobId" element={<JobDetailPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                    <Route path="/admin/login" element={<AdminLoginPage />} />
                    <Route
                      path="/admin/dashboard"
                      element={
                        <AdminRoute>
                          <AdminDashboardPage />
                        </AdminRoute>
                      }
                    />
                    <Route
                      path="/admin/manage"
                      element={
                        <AdminRoute>
                          <AdminManagementPage />
                        </AdminRoute>
                      }
                    />
                  </Routes>
                </Layout>
              </Router>
            </AdminAuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;